import { FC, ReactNode } from 'react';
import Header from './Header';
import Content from './Content';
import Footer from './Footer';

const Template: FC<{ children: ReactNode }> = props => {
  return (
    <>
      <Header />
      <Content>{props.children}</Content>
      <Footer />
    </>
  );
};

export default Template;
